import React from "react";
import { connect } from "react-redux";
import StyledCheckbox from "../../Shared/StyledCheckbox";
import CustomScroll from "react-custom-scroll";

const Filters = ({ _, User, filters, updateState }) => {
  const getFilters = (itemCount, children) => {
    if (itemCount > 5)
      return (
        <CustomScroll heightRelativeToParent={"200px"} allowOuterScroll={true}>
          {children}
        </CustomScroll>
      );
    else return children;
  };

  const updateFilters = (payload) => {
    const filter = filters[payload.filterName].find((f) => f.id === payload.id);
    filter.isChecked = payload = payload.value;
    updateState({
      pageNumber: 1,
      selectedItemIds: [],
      filters,
    });
  };
  const { sortFields, ...restFilter } = filters;
  return (
    restFilter && (
      <div className="search-options-area">
        <div className="row">
          {Object.keys(restFilter).map((filterItem) => (
            <div className="col search-checkboxes" key={filterItem}>
              <h6>{_.PhysicalSearch.Filters[filterItem]}</h6>
              <div className=" filters-list">
                {getFilters(
                  restFilter[filterItem].length,
                  restFilter[filterItem].map((filter) => (
                    <div
                      key={filter.filterName}
                      className="checkbox-text-flex d-flex flex-row"
                    >
                      <StyledCheckbox
                        checked={filter.isChecked}
                        onChange={() =>
                          updateFilters({
                            filterName: filterItem,
                            id: filter.id,
                            value: !filter.isChecked,
                          })
                        }
                      />
                      <span className="filter-name">{filter.filterName}</span>
                      {filter.count > 0 && (
                        <span className="orange-text">({filter.count})</span>
                      )}
                    </div>
                  ))
                )}
              </div>
              {filterItem === "customerFilters" && (
                <p>
                  For :{" "}
                  <span className="viking-text">{User["user-email"]}</span>
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    )
  );
};
export const mapStateToProps = ({ _, User }) => ({ _, User });
export default connect(mapStateToProps)(Filters);
